import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './TopBarContainer.css';
import DeletePage from './../top-bar-buttons/delete-page/deletePage';
import AddNewPage from './../top-bar-buttons/add-new-page/addNewPage';
import SaveState from './../top-bar-buttons/save-state/saveState';
import Margin from './../top-bar-buttons/margin/margin';
import Colors from './../top-bar-buttons/colors/Colors';
import InsertText from './../top-bar-buttons/insert-text/insertText';
import { GetActivePage, getCurrentLayout } from './../../../redux/helpers';
import { disableButtonsByType, placeCard, tableNumber } from './../../..//helpers/weddingHelper';

import {
  coverWithTextAndWithoutSpine,
  coversWithText } from './../../../helpers/coverHelper';

class TopBarContainer extends Component {
  constructor(props) {
    super(props);
  }


  activePage = () => {
    const { byId } = this.props.pages;
    return Object.values(byId).find(element => element.isActive);
  }

  coverText = () => {
    const { coverType } = this.props;
    const { isCover } = this.activePage();
    const coverText = coverWithTextAndWithoutSpine().concat(coversWithText());
    return coverText.some(element => !isCover || element === coverType);
  }

  isInnerPage = () => {
    const { isCover } = this.activePage();
    return isCover;
  }

  renderDeleteComponent = (type) => {
    const {
      pages,
      lang,
    } = this.props;


    return (
      <DeletePage
        pages={pages}
        isChange={false}
        lang={lang}
        type={type}
      />
    );
  }

  renderComponents = () => {
    const {
      pages,
      pageBackgroundColor,
      lang,
      coverType,
      pageBackgroundImage,
      pageBackgroundImageFull,
      sizes,
      ratio,
      bookId,
      layouts,
      hasParent,
    } = this.props;


    const activePage = GetActivePage(pages.byId);

    if (!activePage) {
      return null;
    }


    const { type } = this.props.layouts[activePage.layout] || 0;
    let isPlaceCard = false;
    let isTableNumber = false;
    let disabeComponentByType = false;
    if (getCurrentLayout(layouts, activePage.layout)) {
      const currentPageLayoutType = getCurrentLayout(layouts, activePage.layout).type;
      disabeComponentByType = disableButtonsByType(currentPageLayoutType);
      isPlaceCard = currentPageLayoutType === placeCard;
      isTableNumber = currentPageLayoutType === tableNumber;
    }

    return (
      <div>
        { !disabeComponentByType && <AddNewPage
          isChange={false}
          pages={pages.allIds}
          pagesById={pages.byId}
          pageBackgroundColor={pageBackgroundColor}
          pageBackgroundImage={pageBackgroundImage}
          pageBackgroundImageFull={pageBackgroundImageFull}
          sizes={sizes}
          lang={lang}
          ratio={ratio}
          bookId={bookId}
          type={type}
        /> }
        { !disabeComponentByType && this.renderDeleteComponent(type) }
        { !disabeComponentByType && !isTableNumber && !isPlaceCard && <Margin
          lang={lang}
        />
        }
        { Object.keys(hasParent).length === 0 && <Colors
          isCover={activePage.isCover}
          pageId={activePage.id}
          pageOrder={activePage.order}
          pages={pages.allIds}
          lang={lang}
          coverType={coverType}
        />
        }
        { this.coverText() && <InsertText
          lang={lang}
          pageId={activePage.id}
          isTextLayout={this.isInnerPage()}
          coverType={coverType}
        />
        }
      </div>
    );
  }

  render() {
    const {
      lang,
      bookId,
    } = this.props;

    return (
      <div className="Topbar-wrapper">
        { this.renderComponents() }
        <div className="last-elements">
          <SaveState
            lang={lang}
            bookId={bookId}
          />
        </div>
      </div>
    );
  }
}

TopBarContainer.defaultProps = {
  pageBackgroundColor: '#fff',
  pageBackgroundImage: '',
  pages: {},
  lang: {},
  bookId: 1,
  coverType: 'fotos',

};

TopBarContainer.propTypes = {
  pageBackgroundColor: PropTypes.string,
  pageBackgroundImage: PropTypes.string,
  pages: PropTypes.object,
  lang: PropTypes.object,
  bookId: PropTypes.number,
  coverType: PropTypes.string,

};

export default connect(state => ({
  pages: state.entities.pages,
  pageBackgroundColor: state.editorUI.bookProperties.backgroundColor,
  pageBackgroundImage: state.editorUI.bookProperties.backgroundImage,
  pageBackgroundImageFull: state.editorUI.bookProperties.backgroundImageFull,
  sizes: state.editorUI.bookProperties.backgroundSize,
  bookId: state.bookProperties.photoBookId,
  layouts: state.entities.layouts.byId,
  backgrounds: state.backgrounds,
  hasParent: state.bookProperties.parentStyle,
}))(TopBarContainer);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-container/TopBarContainer.jsx